<template>
    <div class="agreement">
        <div class="agree-wrapper">
            <div class="agree-list">
                <div class="list-item" @click="type='user'">
                    <div class="item-preview">
                        <div class="preview-content" v-html="setting.userAgreement"></div>
                    </div>
                    <div class="item-title">《用户行为准则》</div>
                </div>
                <div class="list-item" @click="type='privacy'">
                    <div class="item-preview">
                        <div class="preview-content" v-html="setting.privacy"></div>
                    </div>
                    <div class="item-title">《设计师合作协议》</div>
                </div>
                <div class="list-item" @click="type='orderPurchase'">
                    <div class="item-preview">
                        <div class="preview-content" v-html="setting.orderPurchaseAgreement"></div>
                    </div>
                    <div class="item-title">《订单采购合同》</div>
                </div>
            </div>
            <div class="agree-content" v-html="agreement"></div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
export default{
    data(){
        return{
            type:'user'
        }
    },
    computed:{
        ...mapState({
            setting:state=>state.setting
        }),
        agreement(){
            const {userAgreement,privacy,orderPurchaseAgreement} = this.setting;
            if(this.type === 'user') return userAgreement;
            if(this.type === 'orderPurchase') return orderPurchaseAgreement;
            return privacy;
        }
    },
    mounted(){},
    methods:{}
}
</script>
<style lang="scss" scoped>
.agreement{
    width:100%;
    min-height:calc(100vh - 165px);
    background:#f8f6f9;
    .agree-wrapper{
        width:100%;
        padding:40px 0 0 60px;
        display:flex;
        column-gap:74px;
        .agree-list{
            display:flex;
            flex-direction:column;
            row-gap:26px;
            width:fit-content;
            .list-item{
                display:flex;
                flex-direction:column;
                align-items:center;
                justify-content:center;
                row-gap:10px;
                width:fit-content;
                cursor:pointer;
                .item-preview{
                    width:120px;
                    height:150px;
                    background:#ffffff;
                    overflow:hidden;
                    border:1px solid #e0e0e0;
                    padding:3px;
                    .preview-content{
                        width:100%;
                        zoom:0.15;
                    }
                }
                .item-title{
                    color:#4d4d4d;
                    font-size:14px;
                }
            }
        }
        .agree-content{
            width:1000px;
            max-height:calc(100vh - 210px);
            background:#ffffff;
            padding:40px 50px;
            overflow-y:auto;
        }
    }
}

/* 富文本（v-html 注入，需 ::v-deep 穿透）：admin 返回的协议含 table 时补样式 */
::v-deep .preview-content,
::v-deep .agree-content {
    color: #333333;
    font-size: 14px;
    line-height: 1.8;
    word-break: break-word;

    p {
        margin: 0 0 10px;
    }
    h1,
    h2,
    h3,
    h4,
    h5 {
        margin: 16px 0 8px;
        color: #1a1a1a;
        font-weight: bold;
        line-height: 1.5;
    }
    h1 {
        font-size: 18px;
    }
    h2 {
        font-size: 17px;
    }
    h3 {
        font-size: 16px;
    }
    h4,
    h5 {
        font-size: 15px;
    }
    ul {
        list-style: disc;
        padding-left: 20px;
        margin: 0 0 10px;
    }
    ol {
        list-style: decimal;
        padding-left: 20px;
        margin: 0 0 10px;
    }
    li {
        margin-bottom: 4px;
    }
    strong,
    b {
        color: #1a1a1a;
    }
    a {
        color: #fa3d5a;
    }
    img {
        max-width: 100%;
        height: auto;
    }
    table {
        border-collapse: collapse;
        width: 100%;
        margin: 12px 0;

        th,
        td {
            border: 1px solid #e0e0e0;
            padding: 6px 10px;
            text-align: left;
        }
        th {
            background: #fafafa;
            font-weight: bold;
        }
    }
}
</style>